// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminStatistics_wrapper__JaSEi","container":"AdminStatistics_container__fs-Nl"};